import * as moment from 'moment';
import 'moment/locale/de';

class TabletHelper {
    static setSupporterAvailable(data, supporter) {
        if(data.find((el) => el === supporter.id)) {
            let index = data.indexOf(supporter.id);
            data.splice(index, 1);
        } else {
            data.push(supporter.id);
        }
    }

    static checkInSupporter(actions, supporter, shiftId) {
        supporter.checkedIn = !supporter.checkedIn;
        actions.push({
            createdAt: moment(),
            sentToServer: false,
            action: supporter.checkedIn ? 'CHECKIN' : 'CHECKIN_REVERT',
            supporterProjectId: supporter.supporterProjectId,
            shiftId: shiftId
        });
    }

    static addSupporterToShift(actions, data, supportersAvailable, supporters, timeSlot, supporterId, location) {
        let timeSlotObj = data.find((el) => el.date === timeSlot);
        let found = false;
        for(let route in timeSlotObj.routes) {
            for(let locationi in timeSlotObj.routes[route].locations) {
                for(let shifti in timeSlotObj.routes[route].locations[locationi].shifts) {
                    let index = timeSlotObj.routes[route].locations[locationi].shifts[shifti].supporters.findIndex((el) => el.id === parseInt(supporterId));
                    if(index >= 0) {
                        timeSlotObj.routes[route].locations[locationi].shifts[shifti].supporters.splice(index, 1);
                        found = true;
                        break;
                    }
                }
                if(found) break;
            }
            if(found) break;
        }
        let supporter = supporters.find((el) => el.id === parseInt(supporterId));
        supportersAvailable.push(supporter.id);
        location.shifts[0].supporters.push(supporter);

        actions.push({
            createdAt: moment(),
            sentToServer: false,
            action: 'ADD_TO_SHIFT',
            supporterProjectId: supporter.supporterProjectId,
            shiftId: location.shifts[0].id
        });
    }
}
export default TabletHelper;